import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Services } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { FiltersProvider } from '@context';
import { useData } from '@hooks/useData';
import { useGetAllCarouselData } from '@services/useGetAllCarouselData';

export function ServicesPage() {
    const { request: requestAllCarouselData } = useGetAllCarouselData();
    const { allSettings, allCarouselData } = useData();
    const { t } = useTranslation();

    const translations = {
        title: t('services-component.metatags.title', { marketplace: allSettings?.data?.marketplaceName }),
        description: t('services-component.metatags.description', { marketplace: allSettings?.data?.marketplaceName }),
    };

    const seoImage = allCarouselData?.data?.[0]?.desktopImg;

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        image: seoImage?.src
            ? {
                  src: seoImage.src || '',
                  type: seoImage.type,
                  width: seoImage.width,
                  height: seoImage.height,
                  alt: allCarouselData?.data?.[0].title || '',
              }
            : undefined,
        url: SITE_URLS.services,
        index: true,
    });

    useEffect(() => {
        !allCarouselData && requestAllCarouselData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allCarouselData]);

    return (
        <FiltersProvider>
            <Services />
        </FiltersProvider>
    );
}
